import { SnackBarIconType } from 'common/constants';

import { AppLoaderState, iSnackBar, AppConfig, SnackbarType } from 'common/interfaces';
import { IUserProfile } from 'common/interfaces/iprofile';
import UILogger from 'common/utils/logger';
import { config } from 'config';
import { AppActions } from 'reducers/app-reducer';
import { fetchAppConfig, getUserAppConfig } from 'services/app-service';
import { postUserLogout } from 'services/auth-service';

import { useAppDispatch } from 'setup/store';
import { initHtttpAuthHeader } from 'services/config';
import { clearLocalData } from 'services/db-service';
import { resetAnalyticsUser } from 'services/analytics-service';

export const useAppActions = () => {
  const dispatch = useAppDispatch();

  const initDynamicUserConfig = async () => {
    // const resp = await getUserAppConfig({ generalConfig: true });
  };

  const init = async (config: AppConfig) => {
    UILogger.log('Initializing app selector, config: ', config);
    getAppConfig(config);
  };
  const setUserLoggedIn = (isLoggedIn: boolean) => {
    dispatch(AppActions.setIsUserLoggedIn(isLoggedIn));
    doPostLoginAction();
  };

  const setLoggedInUser = (user: IUserProfile) => {
    dispatch(AppActions.setLoggedInUser(user));
    init(config.appConfig);
  };

  const getAppConfig = async (appConfig: AppConfig) => {
    const configResp = await fetchAppConfig(appConfig?.appVersionId);
    UILogger.log('Appconfig received: succes', configResp.status.success);
    if (configResp.status.success) {
      dispatch(AppActions.setAppConfig(configResp.data));
    }
    return configResp;
  };

  const setLoading = (isLoading: boolean) => {
    dispatch(AppActions.setLoading(isLoading));
  };

  const setAppLoader = (appLoaderState: AppLoaderState) => {
    dispatch(AppActions.setAppLoaderState(appLoaderState));
  };

  const doPostLoginAction = async () => {
    initDynamicUserConfig();
  };
  const clearAppReduxStates = () => {
    UILogger.log('Clearing all redux states**');
    dispatch({ type: 'CLEAR_ALL_REDUX_STATES' });
  };

  const doPostLogoutCleanup = async () => {
    UILogger.log('doPostLogoutCleanup: cleaning up data ');
    resetAnalyticsUser();
    clearLocalData();
    await initHtttpAuthHeader();
    clearAppReduxStates();
    dispatch(AppActions.logoutUser());
    init(config.appConfig);
  };
  const logoutUser = async () => {
    setLoading(true);
    const resp = await postUserLogout();
    if (resp.status.success) {
      doPostLogoutCleanup();
    } else {
      const errMsg = resp.status.msg || 'Error in user logout. Please try again';
      showSnackBar(SnackbarType.ERROR, errMsg);
    }
    setLoading(false);
    return resp?.status?.success;
  };

  const setSnackBar = (
    visible: boolean,
    message: string,
    type: SnackbarType,
    iconType?: SnackBarIconType,
    showTime: number = 2000,
    autoCloseDisabled?: boolean,
    disableClose?: boolean,
  ) => {
    const snackbarState = {
      visible: visible,
      message: message,
      type: type,
      showTime: showTime,
      iconType,
      autoCloseDisabled,
      disableClose,
    } as iSnackBar;
    dispatch(AppActions.updateSnackBar(snackbarState));
  };

  const showSnackBar = (
    type: SnackbarType,
    message: string,
    iconType?: SnackBarIconType,
    showTime: number = 5000,
    delay: number = 0,
    autoCloseDisabled?: boolean,
    disableClose?: boolean,
  ) => {
    const snackbarState = {
      visible: true,
      message: message,
      type: type,
      showTime,
      iconType,
      autoCloseDisabled,
      disableClose,
    } as iSnackBar;
    setTimeout(() => dispatch(AppActions.updateSnackBar(snackbarState)), delay);
  };

  const showSuccessSnackBar = (message: string) => {
    showSnackBar(SnackbarType.SUCCESS, message);
  };

  const resetSnackBar = () => {
    dispatch(AppActions.resetSnackBar());
  };

  const askLocationPermission = () => {};
  const setAppConnected = (isConnected: boolean) => {};

  const setAppInitialized = (initialised: boolean) => {
    UILogger.log('setAppInitialized: ', initialised);
    dispatch(AppActions.setIsAppInitialized(initialised));
  };
  return {
    init,
    setLoggedInUser,
    setUserLoggedIn,
    doPostLoginAction,
    setLoading,
    logoutUser,
    setSnackBar,
    showSnackBar,
    setAppLoader,
    doPostLogoutCleanup,
    setAppConnected,
    setAppInitialized,
    resetSnackBar,
    showSuccessSnackBar,
  };
};
